import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { ActiveToggleIcon, InActiveToggleIcon } from './Icons'
import {
  FUNDAMENTAL_TOGGLE_COLOR,
  TOGGLE_INDEX,
} from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  newToggleGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 12,
  },
  newToggleGroupMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flexStart',
    marginTop: '20px !important',
  },
  toggleItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginRight: 0,
    cursor: 'pointer',
  },
  toggleDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    flexShrink: 0,
  },
  toggleIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  toggleTitle: {
    lineHeight: '18px',
    fontWeight: 400,
    marginLeft: 8,
    fontSize: 13,
    '@media only screen and (min-width: 1200px)': {
      fontSize: 11,
    },
    '@media only screen and (min-width: 1500px)': {
      fontSize: 12,
    },
    '@media only screen and (max-width: 900px)': {
      fontSize: 12,
    },
    '@media only screen and (max-width: 1199px)': {
      fontSize: 11,
    },
  },
  toggleIconRight: {
    marginLeft: 8,
  },
})

interface NewToggleGroupProps {
  companyColor?: any
  peerGroupColor?: any
  equityColor?: any
  marketAssetsColor?: any
  assetVolatilityColor?: any
  leverageColor?: any
  unrecognisedRiskStatusColor?: any
  riskEventsColors?: any
  companyText?: any
  peerGroupText?: any
  equityText?: any
  marketAssetsText?: any
  assetVolatilityText?: any
  leverageText?: any
  unrecognisedRiskStatusText?: any
  riskEventsText?: any
  inModal?: boolean
  toggleObj?: any
  setToggleObj?: any
  showPeerGroup?: any
  showCompany?: any
  showEquityPrice?: any
  showMarketValueOfAssets?: any
  showAssetVolatility?: any
  showLeverage?: any
  showUnrecognisedRiskStatus?: any
  showRiskEvents?: any
}

const ChartD3ToggleGroup = ({
  companyColor,
  peerGroupColor,
  equityColor,
  marketAssetsColor,
  assetVolatilityColor,
  leverageColor,
  unrecognisedRiskStatusColor,
  riskEventsColors,
  companyText,
  peerGroupText,
  equityText,
  marketAssetsText,
  assetVolatilityText,
  leverageText,
  unrecognisedRiskStatusText,
  riskEventsText,
  inModal,
  toggleObj,
  setToggleObj,
  showPeerGroup,
  showCompany,
  showEquityPrice,
  showMarketValueOfAssets,
  showAssetVolatility,
  showLeverage,
  showUnrecognisedRiskStatus,
  showRiskEvents,
}: NewToggleGroupProps) => {
  const classes = useStyles()
  const [toggleData, setToggleData] = useState({
    companyValue: true,
    peerGroupValue: false,
    equityValue: false,
    marketValueAssetValue: false,
    assetVolatilityValue: false,
    leverageValue: false,
    unrecognisedRiskStatusValue: true,
    riskEventsValue: true,
  })

  useEffect(() => {
    if (toggleObj) {
      setToggleData({
        companyValue: toggleObj.showCompanyHistory,
        peerGroupValue: toggleObj.showPeerGroup,
        equityValue: toggleObj.showEquityPrice,
        marketValueAssetValue: toggleObj.showMarketValueOfAssets,
        assetVolatilityValue: toggleObj.showAssetVolatility,
        leverageValue: toggleObj.showLeverage,
        unrecognisedRiskStatusValue: toggleObj.showUnrecognisedRiskStatus,
        riskEventsValue: toggleObj.showRiskEvents,
      })
    }
  }, [toggleObj])

  const onToggleItem = (index: number) => {
    const cloned = JSON.parse(JSON.stringify(toggleData))

    index === TOGGLE_INDEX.COMPANY_HISTORY &&
      (cloned.companyValue = !cloned.companyValue)
    index === TOGGLE_INDEX.PEER_GROUP &&
      (cloned.peerGroupValue = !cloned.peerGroupValue)
    index === TOGGLE_INDEX.EQUITY_PRICE &&
      (cloned.equityValue = !cloned.equityValue)
    index === TOGGLE_INDEX.MARKET_VALUE_OF_ASSET &&
      (cloned.marketValueAssetValue = !cloned.marketValueAssetValue)
    index === TOGGLE_INDEX.ASSET_VOLATILITY &&
      (cloned.assetVolatilityValue = !cloned.assetVolatilityValue)
    index === TOGGLE_INDEX.LEVERAGE &&
      (cloned.leverageValue = !cloned.leverageValue)
    index === TOGGLE_INDEX.UNRECOGNISED_RISK_STATUS &&
      (cloned.unrecognisedRiskStatusValue = !cloned.unrecognisedRiskStatusValue)
    index === TOGGLE_INDEX.RISK_EVENTS &&
      (cloned.riskEventsValue = !cloned.riskEventsValue)
    setToggleObj({
      showCompanyHistory: cloned.companyValue,
      showPeerGroup: cloned.peerGroupValue,
      showEquityPrice: cloned.equityValue,
      showMarketValueOfAssets: cloned.marketValueAssetValue,
      showAssetVolatility: cloned.assetVolatilityValue,
      showLeverage: cloned.leverageValue,
      showUnrecognisedRiskStatus: cloned.unrecognisedRiskStatusValue,
      showRiskEvents: cloned.riskEventsValue,
    })
    setToggleData(cloned)
  }

  return (
    <div
      className={
        isMobile ? classes.newToggleGroupMobile : classes.newToggleGroup
      }
      style={{
        justifyContent: inModal ? 'flex-end' : 'flex-start',
        marginTop: inModal ? 20 : 10,
      }}
    >
      {showCompany && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.COMPANY_HISTORY)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: companyColor || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {companyText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.companyValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showPeerGroup && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.PEER_GROUP)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: peerGroupColor || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {peerGroupText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.peerGroupValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showEquityPrice && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.EQUITY_PRICE)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: equityColor || '#A3A3A3' }}
          />
          <div className={classes.toggleTitle} style={{ color: '#5E5E5E' }}>
            {equityText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.equityValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showMarketValueOfAssets && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.MARKET_VALUE_OF_ASSET)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: marketAssetsColor || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {marketAssetsText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.marketValueAssetValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showLeverage && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.LEVERAGE)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: leverageColor || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {leverageText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.leverageValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showAssetVolatility && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.ASSET_VOLATILITY)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: assetVolatilityColor || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {assetVolatilityText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.assetVolatilityValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showUnrecognisedRiskStatus && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.UNRECOGNISED_RISK_STATUS)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{
              backgroundColor: unrecognisedRiskStatusColor || '#A3A3A3',
            }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {unrecognisedRiskStatusText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.unrecognisedRiskStatusValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}

      {showRiskEvents && (
        <div
          onClick={() => onToggleItem(TOGGLE_INDEX.RISK_EVENTS)}
          className={classes.toggleItem}
        >
          <span
            className={classes.toggleDot}
            style={{ backgroundColor: riskEventsColors || '#A3A3A3' }}
          />
          <div
            className={classes.toggleTitle}
            style={{
              color: '#5E5E5E',
            }}
          >
            {riskEventsText}
          </div>
          <div className={`${classes.toggleIcon} ${classes.toggleIconRight}`}>
            {toggleData.riskEventsValue ? (
              <ActiveToggleIcon />
            ) : (
              <InActiveToggleIcon />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

ChartD3ToggleGroup.defaultProps = {
  companyColor: FUNDAMENTAL_TOGGLE_COLOR.COMPANY_HISTORY,
  peerGroupColor: FUNDAMENTAL_TOGGLE_COLOR.PEER_GROUP,
  equityColor: FUNDAMENTAL_TOGGLE_COLOR.EQUITY_PRICE,
  marketAssetsColor: FUNDAMENTAL_TOGGLE_COLOR.MARKET_VALUE_OF_ASSET,
  assetVolatilityColor: FUNDAMENTAL_TOGGLE_COLOR.ASSET_VOLATILITY,
  leverageColor: FUNDAMENTAL_TOGGLE_COLOR.LEVERAGE,
  unrecognisedRiskStatusColor:
    FUNDAMENTAL_TOGGLE_COLOR.UNRECOGNISED_RISK_STATUS,
  riskEventsColors: FUNDAMENTAL_TOGGLE_COLOR.RISK_EVENTS,
  companyText: 'Show Company History',
  peerGroupText: 'Show Peer Group',
  equityText: 'Show Equity Price',
  marketAssetsText: 'Show $USD Market Value of Assets',
  assetVolatilityText: 'Show Asset Volatility',
  leverageText: 'Show Market Value of Leverage',
  unrecognisedRiskStatusText: 'Show Unrecognised Risk Status',
  riskEventsText: 'Show Risk Events',
}

export default ChartD3ToggleGroup
